/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */

import {Version} from '@angular/core';

/** Current version of Angular Flex-Layout. */
export const VERSION = new Version('2.0.0-beta.8-d171c33');



// WEBPACK FOOTER //
// ../../src/lib/version.ts